import './App.css';
import Simulateur from './components/Simulateur';
import '@iframe-resizer/child';

function App() {
  return (
    <div className="App">
      <Simulateur />
    </div>
  );
}

export default App;
